module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/person-with-box/person-with-box@2x.svg"